import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Box, TextField, IconButton } from "@mui/material";
import { theme } from "../../theme";
import ImageUploading, { ImageListType } from "react-images-uploading";
import { t } from "i18next";
import { RemoveCircle, UploadFile } from "@mui/icons-material";
import { getBase64 } from "../../utils/common";

interface IImageUploadFieldProps {
  content: string;
  label?: string;
  edit?: boolean;
  onValueChanged?: (val: string) => void;
  onSetReady?: () => void;
}

export const ImageUploadField = (props: IImageUploadFieldProps) => {
  const [images, setImages] = React.useState([]);

  const {
    onSetReady,
    content,
  } = props;
  useEffect(() => onSetReady && onSetReady(), [onSetReady]);

  const onChange = async (
    imageList: ImageListType,
  ) => {
    setImages(imageList as never[]);

    if (imageList[0].file && props.onValueChanged) {
      const base64 = await getBase64(imageList[0].file);
      props.onValueChanged(base64);
    }
  };

  const imageUploadCallback = useCallback(
    ({
      imageList,
      onImageUpload,
      onImageRemoveAll,
      onImageUpdate,
      onImageRemove,
    }: any) => (
      // write your building UI
      <Box
        sx={{ display: "flex" }}
        style={{
          flex: 1,
          flexDirection: "row",
          marginTop: theme.spacing(2),
        }}
        className="upload__image-wrapper"
      >
        <Box style={{ flex: 1 }}>
          {imageList.length ? (
            (imageList as ImageListType).map((image, index) => (
              <TextField
                style={{ width: "100%" }}
                inputProps={{ readOnly: true }}
                value={image.file?.name}
                label={props.label}
              />
            ))
          ) : (
            <TextField
              style={{ width: "100%"}}
              inputProps={{ readOnly: true }}
              value={content ? t("savedImage") : ""} // content: base64, or blob name
              label={props.label}
            />
          )}
        </Box>
        <Box style={{alignSelf: "center"}}>
          {(imageList.length || content) ? (
            <IconButton onClick={() => {
                onImageRemoveAll()
                props.onValueChanged && props.onValueChanged("")
                }}>
              <RemoveCircle />
            </IconButton>
          ) : (
            <IconButton onClick={onImageUpload}>
              <UploadFile />
            </IconButton>
          )} 
          {/* TODO: preview-button. */}
        </Box>
      </Box>
    ),
    [
      content,
    ]
  );

  return (
    <Box width={"100%"} height={"100%"} position={"relative"}>
      {props.edit && (
        <ImageUploading
          key={"imageUploading_"+props.label}
          value={images}
          onChange={onChange}
          maxNumber={1}
          dataURLKey="data_url"
        >
          {imageUploadCallback}
        </ImageUploading>
      )}
    </Box>
  );
};
